import { useGetUnitControlListWithState } from '@apps-common/apis/portal/control'
import { UnitControlPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/controls'

export const UnitControls = () => <UnitControlPage requestHook={useGetUnitControlListWithState} />
